module.exports = __webpack_public_path__ + "static/gallery-9@2x-267f1ac2efb61e1a1dfc3cf5571ced7e.jpg";